import * as React from 'react';
import { styled } from '@glitz/react';
import { PackageIcon } from 'svenssons/shared/icons';
import { Translation, translate, useCurrentCountry } from '@avensia/excite';
import { useFormatPrice } from '@avensia/excite-ui';
import { ResetButton } from 'webapp/components/button/button';
const CountryFlag = React.lazy(() => import('../../components/country-flag'));

type PropType = {
  showShippingInfo?: () => void;
  freeShipping: boolean;
  lowestShippingPrice: number;
};

export const ShippingInfo = ({ showShippingInfo, freeShipping, lowestShippingPrice }: PropType) => {
  const currentCountry = useCurrentCountry();
  const formatPrice = useFormatPrice();
  const [showFlag, setShowFlag] = React.useState(false);

  React.useEffect(() => {
    setShowFlag(true);
  }, []);

  return (
    <Container>
      <PackageIcon />
      {showFlag && (
        <Text suppressHydrationWarning>
          {freeShipping ? (
            <Translation
              text={t => t.product.freeShipping}
              args={{
                ['country']: (
                  <React.Fragment key={currentCountry.twoLetterCode}>
                    <React.Suspense>
                      <FlagIcon countryCode={currentCountry.twoLetterCode} /> {currentCountry.localName}
                    </React.Suspense>
                  </React.Fragment>
                ),
              }}
            />
          ) : (
            <Translation
              text={t => t.product.shippingPrice}
              args={{
                ['country']: (
                  <React.Fragment key={currentCountry.twoLetterCode}>
                    <React.Suspense>
                      <FlagIcon countryCode={currentCountry.twoLetterCode} /> {currentCountry.localName}
                    </React.Suspense>
                  </React.Fragment>
                ),
                ['shipping_price']: formatPrice(lowestShippingPrice),
              }}
            />
          )}
        </Text>
      )}
      <ShowMoreButton onClick={showShippingInfo}>{translate(t => t.productPage.shippingInfoShowMore)}</ShowMoreButton>
    </Container>
  );
};

const Container = styled.div({
  display: 'grid',
  gridTemplateColumns: '24px auto auto',
  gridGap: t => t.sharedSpacing.m,
  alignItems: 'center',
  padding: { xy: t => t.sharedSpacing.m },
  border: { xy: { style: 'solid', color: t => t.borderStrongColor, width: 1 }, top: { style: 'none' } },
});

const Text = styled.span({
  fontSize: t => t.sharedFontSize.xs,
  display: 'inline-flex',
  flexWrap: 'wrap',
  columnGap: t => t.sharedSpacing.xs,
});

const ShowMoreButton = styled(ResetButton, {
  fontSize: t => t.sharedFontSize.xs,
  textDecoration: 'underline',
  justifySelf: 'end',
});

const FlagIcon = styled(CountryFlag, {
  flexShrink: 0,
  margin: { x: 0 },
});
